module.exports = __webpack_public_path__ + "static/media/img11.09481b46.jpg";